// extracted by mini-css-extract-plugin
export default {"background":"style_background__q07xx","container":"style_container__cAn43","circle":"style_circle__i2zuV","checkIcon":"style_checkIcon__n0nld"};